module.exports = __webpack_public_path__ + "static/media/uiux.d9e71876.png";